<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<el-container>
			<el-header style="height: auto;padding-left: 0px;"><!--工具条-->
				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-form :inline="true" :model="filters" class="filterForm">
						<el-form-item label="排位赛:" label-width="110px">
							<el-select v-model="filters.matchId" placeholder="请选择" size="small" class="formItem250" @change="getRankMatchUserData"
								clearable>
								<el-option v-for="item in rankMatchDict" :key="item.id" :label="item.matchName"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
			</el-header>
			<el-container>
				<el-main style="padding-left: 0px;padding-top: 0px;"> <!--列表-->
					<!--列表-->
					<el-table :data="grid_data" height="calc(100vh - 220px)" border highlight-current-row
						v-loading="listLoading" style="width: 100%;">
					<el-table-column prop="realName" label="用户姓名" width="100"></el-table-column>
						<el-table-column prop="logName" label="用户名" width="150"></el-table-column>
						<el-table-column prop="mobileNo" label="手机号" width="130"></el-table-column>
					<el-table-column prop="totalAnswerTimes" label="答题时长(秒）" width="135"></el-table-column>
					<el-table-column prop="totalScore" label="总得分" width="90" sortable></el-table-column>
						<el-table-column prop="errorNum" label="错误数" width="85" sortable></el-table-column>
					<el-table-column prop="okNum" label="正确数" width="85" sortable></el-table-column>
					<el-table-column prop="okRate" label="正确率" width="85" sortable></el-table-column>
					<el-table-column prop="addTime" label="开始做题时间" min-width="150" :formatter="$util.dateFormatEx"></el-table-column>
					</el-table>
				</el-main>
			</el-container>
		</el-container>

	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
export default {
	components: { pagination },
	data() {
		return {
			filters: {
				matchId:''
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			addTimes: [this.getDefaultDay(), this.getDefaultDay()],
			treeData: [],
			selectedGroupOptions: [],
			defaultProps: {
				children: "children",
				label: "groupName",
				value: "id",
			},
			defaultKeys: [1],
			rankMatchDict: [],
			rankMatchUserDict: []
		}
	},
	methods: {
	   async  getRankMatchData() {
			let formData = this.$util.jsonToForm({
				matchName: '',
				gradeId: '',
				bookVersionId: '',
				seasonId: '',
				status: 0,
				rows: 10000,
				page: 1
			});
		   this.rankMatchDict= (await this.$axios.post("/exercise/getrankmatchlist", formData)).data.data
		   if(this.rankMatchDict.length>0){
				this.filters.matchId=this.rankMatchDict[0].id
			}
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/exercise/getrankmatchuserlist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
	},
	async created() {
		await this.getRankMatchData()
		this.getGridData();
	}
}

</script>

<style scoped></style>
